import React from 'react';
import Register from '_organisms/Register';

import Section from 'react-bulma-companion/lib/Section';

export default function RegisterSection() {
  return (
    <Section className="register-section">
      <Register />
    </Section>
  );
}
